import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHaloPodDataByTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const ThunkGetHaloPodData = createAsyncThunk<IPodData, IProps>(
  'pod/getHaloPodData',
  async ({ psaId, ticketId }) => {
    const r = await getHaloPodDataByTicketId(psaId, ticketId);
    return r.data;
  },
);
